export default __webpack_public_path__ + "static/media/community_mobile.cb1d905a.svg";